import { useLayoutEffect } from "react";
import { deriveClientAccent, parseBrandHex, type AccentSet } from "@/utils/clientAccent";

const NO_BRAND_ACCENT = "#1C1A16";
const THEMES = ["light", "dark"] as const;

function accentProperties(brandHex: string | null | undefined): Record<string, string> {
  const accent = deriveClientAccent(brandHex);
  const properties: Record<string, string> = { "--client-accent": parseBrandHex(brandHex) ?? NO_BRAND_ACCENT };
  for (const theme of THEMES) {
    for (const part of Object.keys(accent[theme]) as (keyof AccentSet)[]) {
      properties[`--accent-${part}-${theme}`] = accent[theme][part];
    }
  }
  return properties;
}

/**
 * Fija el acento del cliente activo como custom properties sobre `<html>` (CSSOM: permitido por la CSP,
 * a diferencia de un `<style>`). `tokens.css` los consume con fallback a la tinta («sin marca»).
 * Layout effect: el color cambia en el mismo frame que el cliente, sin parpadeo del acento anterior.
 */
export function useClientAccent(brandHex: string | null | undefined) {
  useLayoutEffect(() => {
    const style = document.documentElement.style;
    const properties = accentProperties(brandHex);
    for (const [name, value] of Object.entries(properties)) style.setProperty(name, value);
    return () => {
      for (const name of Object.keys(properties)) style.removeProperty(name);
    };
  }, [brandHex]);
}
